module.exports = __webpack_public_path__ + "static/media/infrasoft.c19abc38.png";